import Flickity from 'flickity-imagesloaded';
import _debounce from 'lodash/debounce';
import { getRTL, isKeyEvent } from './_utils';

const componentName = 'FeaturedRentals';

const classes = {
	arrowTabActive: `${componentName}--arrowTabActive`,
	nextSlide: `${componentName}--nextSlide`,
	prevSlide: `${componentName}--prevSlide`,
};

const selectors = {
	carouselContainer: `.${componentName}-rentalCarousel`,
	carouselList: `.${componentName}-rentalCarouselList`,
	carouselSlides: `.${componentName}-rentalItemCarousel`,
	carouselNextButton: `.${componentName}-nextButton`,
	carouselPrevButton: `.${componentName}-prevButton`,
	carouselDots: `.flickity-page-dots`,
};

const a11yHideSlide = slide => {
	$(slide).attr('aria-hidden', 'true').find('a', 'button').attr('tabindex', -1);

	const anchor = $(slide).find('a', 'button').get(0);
	if (anchor) {
		anchor.blur();
	}
};

const a11yShowSlide = (slide, isTabInteraction) => {
	$(slide).attr('aria-hidden', 'false').find('a', 'button').attr('tabindex', 0);

	const anchor = $(slide).find('a', 'button').get(0);
	if (anchor && isTabInteraction) {
		anchor.focus();
	}
};

const initControlStateTabs = (primaryButton, secondaryButton) => {
	primaryButton.focus(() => {
		$(primaryButton).addClass(classes.arrowTabActive);
		$(secondaryButton).addClass(classes.arrowTabActive);
	});

	primaryButton.focusout(() => {
		$(primaryButton).removeClass(classes.arrowTabActive);
		$(secondaryButton).removeClass(classes.arrowTabActive);
	});
};

const setAriaLabel = (element, value) => {
	$(element).attr('aria-hidden', value);
};

const disableTabNavigation = $slides => {
	$slides.each((i, slide) => $(slide).find('a', 'button').attr('tabindex', -1));
};

const initCarousel = $carousel => {
	let userCausedAction = false;
	let isTabInteraction = false;

	const $list = $carousel.find(selectors.carouselList);
	const $slides = $list.find(selectors.carouselSlides);
	const slidesLength = $slides.length;
	const nextButton = $carousel.find(selectors.carouselNextButton);
	const prevButton = $carousel.find(selectors.carouselPrevButton);

	const flickity = new Flickity($list.get(0), {
		cellAlign: 'left',
		pageDots: true,
		rightToLeft: getRTL(),
		prevNextButtons: false,
		imagesLoaded: true,
	});

	$list.get(0).removeAttribute('tabIndex');

	nextButton.on('click.flickity', event => {
		userCausedAction = true;
		flickity.next();

		if (!isKeyEvent(event)) {
			nextButton.blur();
			isTabInteraction = false;
		} else {
			disableTabNavigation($slides);
			isTabInteraction = true;

			if (slidesLength === 2) {
				prevButton.focus();
			}
		}
	});

	prevButton.on('click.flickity', event => {
		userCausedAction = true;
		flickity.previous();

		if (!isKeyEvent(event)) {
			prevButton.blur();
			isTabInteraction = false;
		} else {
			disableTabNavigation($slides);
			isTabInteraction = true;

			if (slidesLength === 2) {
				nextButton.focus();
			}
		}
	});

	const flickityPageDots = $carousel.find(selectors.carouselDots);
	initControlStateTabs(nextButton, prevButton);
	initControlStateTabs(prevButton, nextButton);
	setAriaLabel(flickityPageDots, 'true');

	flickity.on('staticClick', (e, p, cell, index) => flickity.select(index));

	flickity.on('dragStart', () => {
		userCausedAction = true;
	});

	flickity.on('select', () => {
		$slides.each((i, slide) =>
			$(slide).removeClass(`${classes.nextSlide} ${classes.prevSlide}`)
		);

		const selectedIndex = flickity.selectedIndex;
		const cells = flickity.getCellElements();
		const prevIndex = selectedIndex == 0 ? slidesLength : selectedIndex - 1;
		const nextIndex = selectedIndex == slidesLength ? 0 : selectedIndex + 1;
		const prevCell = cells[prevIndex];
		const nextCell = cells[nextIndex];

		$(nextCell).addClass(classes.nextSlide);
		$(prevCell).addClass(classes.prevSlide);

		if (userCausedAction) {
			userCausedAction = false;
		}
	});

	flickity.on('settle', () => {
		const cells = flickity.getCellElements();
		cells.forEach(a11yHideSlide);
		a11yShowSlide(cells[flickity.selectedIndex], isTabInteraction);
	});
};

export default function initCarousels() {
	$(selectors.carouselContainer)
		// Initialize carousel only for sets of more than 1 image
		.filter((i, carousel) => $(carousel).find(selectors.carouselSlides).length > 1)
		.each((i, carousel) => {
			const $carousel = $(carousel);
			initCarousel($carousel);
		});
}
